import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Facilities from "./pages/Facilities";
import HowItWorks from "./pages/HowItWorks";
import MachineMarketplace from "./components/landingPage/Machinemarketplace.jsx";



import UserLayout from "./Users/layouts/UserLayout";
import Dashboard from "./Users/pages/Dashboard";
import MyProjects from "./Users/pages/MyProjects";
import NewPrototype from "./Users/pages/NewPrototype";
import UserFacilities from "./Users/pages/Facilities";
import Machines from "./Users/pages/Machines";
import Experts from "./Users/pages/Experts";
import Quotations from "./Users/pages/Quotations";
import QuotationDetail from "./Users/pages/QuotationDetail";
import Orders from "./Users/pages/Orders";
import Payments from "./Users/pages/Payments";
import Documents from "./Users/pages/Documents";
import Messages from "./Users/pages/Messages";
import Help from "./Users/pages/Help";
import Promotions from "./Users/pages/Promotions";
import MyEnquiries from "./Users/pages/MyEnquiries";


import Howitsworksdata from "./components/landingPage/Howitsworksdata.jsx"
import MachineDetails from './components/landingPage/MachineDetails';
import ScrollToTop from "./components/landingPage/ScrollToTop.jsx";
import Innovatorshome from './components/landingPage/Innovatorshome';
import Facilitieshomepage from './components/landingPage/Facilitieshomepage';
import ExpertConnect from './components/landingPage/ExpertConnect';
import AboutAPIC from './components/landingPage/AboutAPIC'
import ExploreCentresdetals from './components/landingPage/ExploreCentresdetals';
import  FacilityDetails from './pages/FacilityDetails.jsx'



import AdminDashboard from "./admin/AdminDashboard";



import VendorDashboard from "./vendor/VendorDashboard";

import Exports from "./experts/Exports.jsx";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/howitworks" element={<HowItWorks />} />
        <Route path="/machinemarketplace" element={<MachineMarketplace />} />


        <Route path="/app" element={<UserLayout />}>
          {/* dashboard, projects, bookings, quotations... will go here as children */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="my-enquiries" element={<MyEnquiries />} />
          <Route path="projects" element={<MyProjects />} />
          <Route path="new-prototype" element={<NewPrototype />} />
          <Route path="facilities" element={<UserFacilities />} /> {/* Added this line */}
          <Route path="machines" element={<Machines />} />
          <Route path="facilities/:city/machines" element={<Machines />} />
          <Route path="experts" element={<Experts />} />
          <Route path="quotations" element={<Quotations />} />
          <Route path="quotations/:id" element={<QuotationDetail />} />  {/* ✅ Uncomment and fix path */}
          <Route path="orders" element={<Orders />} />
          <Route path="payments" element={<Payments />} />
          <Route path="documents" element={<Documents />} />
          <Route path="messages" element={<Messages />} />
          <Route path="help" element={<Help />} />
          <Route path="promotions" element={<Promotions />} />
         
        </Route>


        <Route path="/machine/:id" element={<MachineDetails />} />
          <Route path="/facility/:id" element={<FacilityDetails />} />
        <Route path="/Innovatorshome" element={<Innovatorshome />} />
        <Route path="/Facilitieshomepage" element={<Facilitieshomepage />} />
        <Route path="/ExpertConnect" element={<ExpertConnect />} />
        <Route path="/AboutAPIC" element={<AboutAPIC />} />
        <Route path="/centre/:id" element={<ExploreCentresdetals />} />
        <Route path="/machineMarketplace" element={<MachineMarketplace />} />


        <Route path="/admin/*" element={<AdminDashboard />} />

        <Route path="/vendor/*" element={<VendorDashboard />} />

        <Route path="/experts/*" element={<Exports />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;